// @ts-nocheck
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { inject, observer } from "../../stores/mobx-compat";
import _ from 'lodash';

import PageHeader from '../ui/PageHeader';
import Card, { CardHead } from '../ui/Card';
import Button from '../ui/Button';
import { RadioCard } from '../ui/Radio';
import Input from '../ui/Input';
import FormGroup from '../ui/FormGroup';
import ConfirmationModal from './ConfirmationModal';

class Settings extends Component {
  constructor(props) {
    super(props);
    const { user = {} } = this.props.store.auth;
    const phone = user.phone_number || '';
    this.state = {
      email: user.email || '',
      phoneNumber: phone.indexOf('+1') === 0 ? phone.substring(2) : phone,
      twoFaType: user.twoFaType || '',
      twoFaCode: '',
      modalOpen: false,
      success: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.user, this.props.user)) {
      this.setState(_.pick(this.props.user, ['email', 'phoneNumber', 'twoFaType']));
    }
  }

  handleFormInput = (_e, { name, value }) => this.setState({ [name]: value });

  updateButtonHandler = () => {
    const { twoFaType, phoneNumber } = this.state;
    if (twoFaType === 'text'
      && (phoneNumber.trim().length !== 10 || +phoneNumber.trim() <= 0)) {
      this.props.store.failure('Please format the phone number correctly.');
      return;
    }
    this.setState({ modalOpen: true, success: false });
  }

  confirm = async () => {
    const res = await this.props.store.auth.editTwoFa(
      this.state.twoFaType.trim(),
      this.state.twoFaCode.trim(),
      `+1${this.state.phoneNumber}`.trim(),
    );
    this.setState({ success: res.success });
  }

  render() {
    const { user } = this.props.store.auth;
    const { twoFaType, phoneNumber } = this.state;
    const userInfo = [
      { name: 'Email', value: user.email },
      { name: 'Status', value: user.status },
      { name: 'Role', value: user.role },
      { name: 'Plan name', value: user.planName },
      { name: 'Plan start', value: user.planStartDate },
    ];
    const noChange = (user.phone_number === `+1${phoneNumber}` && user.twoFaType === twoFaType)
      || ((twoFaType === 'text' || twoFaType === '') && !phoneNumber);

    return (
      <>
        <PageHeader
          eyebrow="Settings"
          title={<>Your <em>account</em>.</>}
          sub="Personal details and security."
        />

        <Card padded className="mb-5">
          <CardHead title="Account" />
          <dl className="m-0 grid gap-2.5 text-[13px]">
            {userInfo.map((r) => (
              <div key={r.name} className="flex items-center justify-between gap-3" style={{ borderBottom: '1px dashed var(--mov-line)', paddingBottom: 8 }}>
                <dt className="text-mov-ink-mute mov-mono text-[11px] uppercase tracking-wider">{r.name}</dt>
                <dd className="m-0 capitalize">{r.value || '—'}</dd>
              </div>
            ))}
          </dl>
        </Card>

        <Card padded>
          <CardHead title="Two-factor authentication" />
          <FormGroup label="Method">
            <div className="grid gap-2" style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
              <RadioCard
                checked={twoFaType === 'text'}
                onClick={() => this.handleFormInput(null, { name: 'twoFaType', value: 'text' })}
                title="Text message"
                sub="Send code via SMS"
              />
              <RadioCard
                checked={twoFaType === 'email'}
                onClick={() => this.handleFormInput(null, { name: 'twoFaType', value: 'email' })}
                title="Email"
                sub="Send code to your inbox"
              />
              <RadioCard
                checked={twoFaType === ''}
                onClick={() => this.handleFormInput(null, { name: 'twoFaType', value: '' })}
                title="Disabled"
                sub="No second factor"
              />
            </div>
          </FormGroup>

          <FormGroup label="Phone number">
            <Input
              prefix="+1"
              placeholder="1234567890"
              value={phoneNumber}
              onChange={(e) => this.handleFormInput(null, { name: 'phoneNumber', value: e.target.value })}
            />
          </FormGroup>

          <div className="flex justify-end">
            <Button
              variant="primary"
              onClick={this.updateButtonHandler}
              disabled={noChange}
            >
              Update
            </Button>
          </div>
        </Card>

        <ConfirmationModal
          open={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false, success: false })}
          confirm={this.confirm}
          formInput={this.handleFormInput}
          original2FaType={user.twoFaType}
          {...this.state}
        />
      </>
    );
  }
}

export default inject('store')(observer(Settings));
